module.exports = __webpack_public_path__ + "static/media/1023475.5d160ed7.png";